var React = require('react');
var DefaultLayout = require('./common/layout');
import '../public/less/login.less';
import { Link } from 'react-router';

const loginForm = React.createClass({
  render: function () {
    return (
      <div className='container'>
          <h2>You have made too many unsuccessful login attempts, try again in 2 hours.</h2>
      </div>
    )
  }
});

module.exports = loginForm;


// WEBPACK FOOTER //
// ./modules/banned.jsx